import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const SubLoading = () => {
  return (
   <div className="text-center ">
      <div className="spinner-border text-primary" />
        </div>
  );
};

export default SubLoading;
